"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateStartDate = exports.CalculateDate = exports.parseUTCStringAsLocal = exports.isPasswordExpiringSoon = exports.toFakeUtcISO = exports.toFakeUtc = void 0;
const provider_user_1 = require("@framework/provider-user");
const normalizeRecorderRangeForSwitch = (range) => {
    if (typeof range === "number") {
        const name = provider_user_1.SelfRecorderRangeEnum[range];
        return typeof name === "string" ? name : String(range);
    }
    const s = String(range).trim();
    if (/^(seconds|minutes|hours|days|weeks|months|years)$/.test(s))
        return s;
    if (/^\d+$/.test(s)) {
        const idx = parseInt(s, 10);
        const name = provider_user_1.SelfRecorderRangeEnum[idx];
        return typeof name === "string" ? name : s;
    }
    return s;
};
// Сдвиг любой даты на +dbTz → fake UTC
const toFakeUtc = (date, dbTzMinutes) => {
    const dt = typeof date === "string" ? new Date(date) : new Date(date.getTime());
    return new Date(dt.getTime() + dbTzMinutes * 60000);
};
exports.toFakeUtc = toFakeUtc;
const toFakeUtcISO = (date, dbTzMinutes) => (0, exports.toFakeUtc)(date, dbTzMinutes).toISOString();
exports.toFakeUtcISO = toFakeUtcISO;
const isPasswordExpiringSoon = (expiryIso, daysBefore = 3) => {
    if (!expiryIso) {
        return false;
    }
    const now = new Date();
    const expiry = new Date(expiryIso);
    if (isNaN(expiry.getTime())) {
        return false;
    }
    const diffDays = (expiry.getTime() - now.getTime()) / (1000 * 60 * 60 * 24);
    return diffDays <= daysBefore;
};
exports.isPasswordExpiringSoon = isPasswordExpiringSoon;
const parseUTCStringAsLocal = (isoString) => {
    const [datePart, timePart] = isoString.replace("Z", "").split("T");
    const [year, month, day] = datePart.split("-").map(Number);
    const [hour, minute, secondMs] = timePart.split(":");
    const [second, ms = "0"] = (secondMs || "0").split(".");
    return new Date(year, month - 1, day, Number(hour), Number(minute), Number(second), Number(ms));
};
exports.parseUTCStringAsLocal = parseUTCStringAsLocal;
class CalculateDate {
    static years(date, years) {
        if (!date || Number.isNaN(date.getTime()))
            return new Date();
        const result = new Date(date);
        result.setFullYear(result.getFullYear() + years);
        return result;
    }
    static month(date, month) {
        if (!date || Number.isNaN(date.getTime()))
            return new Date();
        const result = new Date(date);
        result.setMonth(result.getMonth() + month);
        return result;
    }
    static days(date, days) {
        if (!date || Number.isNaN(date.getTime()))
            return new Date();
        const result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }
    static hours(date, hours) {
        if (!date || Number.isNaN(date.getTime()))
            return new Date();
        const result = new Date(date);
        result.setHours(result.getHours() + hours);
        return result;
    }
    static minutes(date, minutes) {
        if (!date || Number.isNaN(date.getTime()))
            return new Date();
        const result = new Date(date);
        result.setMinutes(result.getMinutes() + minutes);
        return result;
    }
    static seconds(date, seconds) {
        if (!date || Number.isNaN(date.getTime()))
            return new Date();
        const result = new Date(date);
        result.setSeconds(result.getSeconds() + seconds);
        return result;
    }
}
exports.CalculateDate = CalculateDate;
const calculateStartDate = (end, range, value) => {
    if (!end || Number.isNaN(end.getTime()) || Number.isNaN(value) || value <= 0) {
        return new Date();
    }
    const rangeKey = normalizeRecorderRangeForSwitch(range);
    switch (rangeKey) {
        case "seconds":
            return CalculateDate.seconds(end, -value);
        case "minutes":
            return CalculateDate.minutes(end, -value);
        case "hours":
            return CalculateDate.hours(end, -value);
        case "days":
            return CalculateDate.days(end, -value);
        case "weeks":
            return CalculateDate.days(end, -value * 7);
        case "months":
            return CalculateDate.month(end, -value);
        case "years":
            return CalculateDate.years(end, -value);
        default:
            return new Date(end);
    }
};
exports.calculateStartDate = calculateStartDate;
//# sourceMappingURL=utils.js.map